import { render } from "./UnauthorizedView.vue?vue&type=template&id=2fd8b5e8&ts=true"
import script from "./UnauthorizedView.vue?vue&type=script&lang=ts"
export * from "./UnauthorizedView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__